import React, { useMemo } from 'react';
import {
  AppraisalTabsContext as LegacyAppraisalTabsContext,
  DEFAULT_CONTEXT_VALUES as DEFAULT_LEGACY_CONTEXT_VALUES,
} from 'site-modules/shared/components/appraisal/appraisal-tabs/appraisal-tabs-context';
import {
  useAppraisalTabsConfig,
  useAppraisalTabsState,
} from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/context/appraisal-tabs-context';
import { FindVinByAddress } from 'site-modules/shared/components/find-vin-by-address/find-vin-by-address';

/**
 * V2 adapter for the address-to-VIN flow.
 */
export function FindVinByAddressV2(props) {
  const { ctaBtnColor } = useAppraisalTabsConfig();
  const { addressInfo, setAddressInfo, setColors, setMmy } = useAppraisalTabsState();
  const legacyContextValue = useMemo(
    () => ({
      ...DEFAULT_LEGACY_CONTEXT_VALUES,
      addressInfo,
      ctaBtnColor,
      setAddressInfo,
      setColors,
      setMmy,
    }),
    [addressInfo, ctaBtnColor, setAddressInfo, setColors, setMmy]
  );

  return (
    <LegacyAppraisalTabsContext.Provider value={legacyContextValue}>
      <FindVinByAddress {...props} />
    </LegacyAppraisalTabsContext.Provider>
  );
}
